import { put } from 'redux-saga/effects';
import { alertPush, sendError } from '../../../';
import { signUpError, VerificationFetch, verificationSuccess } from '../actions';

export function* verificationSaga(action: VerificationFetch) {
    try {
        // yield call(API.post(verificationConfig), '/identity/users/email/confirm_code', action.payload);
        yield put(verificationSuccess());
        yield put(
            alertPush({
                message: [
                    'Verify Successfully !',
                    'Your email has been successfully verified. You can now sign in and start using our services.',
                ],
                type: 'success',
            }),
        );
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: signUpError,
                },
            }),
        );
    }
}
